'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'

const pageTitles: Record<string, string> = {
  '/app/market': 'Market Pulse',
  '/app/artists': 'Artists',
  '/app/insights': 'AI Insights',
  '/app/watchlist': 'Watchlist',
  '/app/search': 'Search',
  '/app/settings': 'Settings',
}

export function AppHeader() {
  const pathname = usePathname()

  // Get the title based on pathname
  const getTitle = () => {
    for (const [path, title] of Object.entries(pageTitles)) {
      if (pathname === path || pathname.startsWith(path + '/')) {
        return title
      }
    }
    return 'salle.art'
  }

  return (
    <header className="app-header sticky top-0 z-40 glass border-b border-border-subtle">
      <div className="flex items-center justify-between px-4 md:px-6 py-3">
        {/* Mobile: Logo, Desktop: Page title */}
        <div className="flex items-center gap-4">
          {/* Mobile logo */}
          <Link href="/" className="md:hidden flex items-baseline gap-0.5">
            <span className="font-display text-xl font-light text-text-primary">salle</span>
            <span className="text-xs text-text-tertiary">.art</span>
          </Link>

          {/* Desktop page title */}
          <h1 className="hidden md:block font-display text-xl font-light text-text-primary">
            {getTitle()}
          </h1>
        </div>

        {/* Search button (mobile) and actions */}
        <div className="flex items-center gap-3">
          {/* Search button - mobile */}
          <Link
            href="/app/search"
            className="md:hidden p-2 rounded-lg hover:bg-page text-text-secondary transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </Link>

          {/* Search bar - desktop */}
          <Link
            href="/app/search"
            className="hidden lg:flex items-center gap-3 px-4 py-2 rounded-full border border-border bg-page text-text-tertiary hover:border-border-hover transition-colors min-w-[280px]"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <span className="text-sm flex-1 text-left">Search artists, lots, categories...</span>
          </Link>

          {/* Notifications */}
          <button className="relative p-2 rounded-lg hover:bg-page text-text-secondary transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            {/* Notification dot */}
            <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-accent-primary" />
          </button>

          {/* Help */}
          <button className="hidden md:block p-2 rounded-lg hover:bg-page text-text-secondary transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  )
}
